module.exports = __webpack_public_path__ + "img/ushop3.474b5f59.png";